import EF from 'ef/ef';
import Chaplin from 'chaplin';
import QuestionsCollection from 'ef/collections/assessments/questions_collection';
import SectionsCollection from 'ef/collections/sections_collection';
import $ from 'jquery';
import _ from 'lodash';

//this model only works with Foundry
const PollResults = Chaplin.Model.extend({
  initialize: function () {
    _.bindAll(this, 'pollResultsLoaded', 'pollResultsLoadFailed', 'pollResultsLoadLocal');
  },

  fileName: function () {
    return `/local-data/poll_results/${this.get('slug')}.json`;
  },

  url: function () {
    return `${this.get('response_set').endpoint}/response_sets/${this.get('response_set').id}/poll_results`;
  },

  loadPollResults: function (options) {
    this.options = options || {};
    if (EF.options.local) {
      return this.pollResultsLoadLocal();
    } else {
      const onFail = this.options.failToLocal ? this.pollResultsLoadLocal : this.pollResultsLoadFailed;
      return this.fetch(this.options).done(this.pollResultsLoaded).fail(onFail);
    }
  },

  pollResultsLoadLocal: function () {
    const deferred = $.Deferred();
    deferred.done(this.pollResultsLoaded);
    deferred.fail(this.pollResultsLoadFailed);
    try {
      if (!this.fileName()) {
        throw Error(`pollResultsLoadLocal Error: FileName return value is${typeof this.fileName()}`);
      }
      import(this.fileName())
        .then(localData => {
          this.set('local', true);
          deferred.resolve(localData);
        })
        .catch(e => {
          throw Error(e);
        });
    } catch (e) {
      deferred.reject();
    }
    return deferred;
  },

  pollResultsLoaded: function (pollResult) {
    //mini-require js cache de file response and second load doesn't work.
    const results = pollResult.data && pollResult.data.attributes ? pollResult.data.attributes.results : {};
    const pollResultsCopy = this.get('local') ? $.extend(true, {}, results) : results;
    this.set('sections', new SectionsCollection(pollResultsCopy.sections));

    this.trigger('poll_results:load', this);
    EF.trigger('poll_results:load', this);
  },

  pollResultsLoadFailed: function () {
    this.trigger('poll_results:load:failure');
    EF.trigger('poll_results:load:failure');
  },

  filterQuestionsBySection: function (sectionIndex) {
    const section = this.get('sections').at(sectionIndex);
    section.set('questions', new QuestionsCollection(section.get('questions')));

    this.set('sections', new SectionsCollection(section));
  },

  filterQuestionsBySectionAndQuestion: function (sectionIndex, questionIndex) {
    const section = this.get('sections').at(sectionIndex);
    section.set('questions', new QuestionsCollection(section.get('questions')[questionIndex]));

    this.set('sections', new SectionsCollection(section));
  },
});

export default PollResults;
